function getVals() 
{
    // Get slider values
    var parent                  = this.parentNode;
    var selectorparent          = SearchParentsFor( parent, "facets__price" );
    var pricesvalueInputs       = parent.querySelectorAll( "input[type='range']" );
    var min_valueInput          = parseFloat( pricesvalueInputs[0].value );
    var max_valueInput          = parseFloat( pricesvalueInputs[1].value );
    var CurrencySymbol          = parent.getAttribute( 'data-CurrencySymbol' );

    if ( min_valueInput > max_valueInput ) 
    {
        [ min_valueInput, max_valueInput ] = [ max_valueInput, min_valueInput ];
    }
    var min_value       = parent.querySelector( ".rangeValues .min_value" );
    var max_value       = parent.querySelector( ".rangeValues .max_value" );
    
    min_value.innerHTML = CurrencySymbol + min_valueInput;
    max_value.innerHTML = CurrencySymbol + max_valueInput;

    parent.querySelector( ".rangeValues_label .min_value" ).innerHTML = CurrencySymbol + min_valueInput;
    parent.querySelector( ".rangeValues_label .max_value" ).innerHTML = CurrencySymbol + max_valueInput;

    var min_value_textbox       = selectorparent.querySelector( 'input[name="filter.v.price.gte"]' );
    var max_value_textbox       = selectorparent.querySelector( 'input[name="filter.v.price.lte"]' );
    min_value_textbox.value = min_valueInput;
    max_value_textbox.value = max_valueInput;
}

function initializeRangeSliders() 
{
    // Initialize Range Sliders
    var sliderSections = document.querySelectorAll( ".range-slider" );
    sliderSections.forEach(( sliderSection ) => 
    {
        var sliders = sliderSection.querySelectorAll( "input[type='range']" );
        sliders.forEach(( slider ) =>
        {
            slider.addEventListener( "input", getVals );
            // Manually trigger event first time to display values
            slider.dispatchEvent( new Event( "input" ) );
        });
    });
}

function mobileSortEventHandler()
{
    $('input[name="sort_by"]').on('change', function( e )
    {
        var value = e.currentTarget.value;
        var sortSelect = document.querySelector('#SortBy');
        for( var i=0; i < sortSelect.options.length; i++ )
        {
            if( sortSelect.options[i].value === value )
            {
                sortSelect.options.selectedIndex = i;
                break;
            }
        }
    });
}

window.addEventListener( "DOMContentLoaded", function() 
{
    initializeRangeSliders();

    mobileSortEventHandler();

    // Save existing sort parameters - see 'https://shopify.dev/tutorials/customize-theme-add-sort-order-menu'
    Shopify.queryParams = {};
    if(location.search.length) {
        for(var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++)
        {
            aKeyValue = aCouples[i].split('=');
            if(aKeyValue && aKeyValue[0] == "sort_by")
            {
                var currentMobileSort = document.querySelector('input[name="sort_by"][value="' + aKeyValue[1] + '"]');
                if( currentMobileSort )
                {
                    currentMobileSort.checked = true;
                    currentMobileSort.closest(".facet-checkbox").classList.add("facet-mobile-sort-active");
                }
            }
        }
    }

    // Add existing sort parameters to current URL
    var optionsContainer = document.querySelector( ".bridgman-mobile-sort-container" );
    var options          = optionsContainer.querySelectorAll( ".bridgman--sort--container .facet-checkbox" );
    for( var i = 0; i < options.length; i++ )
    {
        var option = options[ i ];
        option.addEventListener( "click", function( e ) {
            var element = e.currentTarget.querySelector( 'input[name="sort_by"]' );
            var activeSort = document.querySelector('.bridgman--sort--container .facet-checkbox.facet-mobile-sort-active');
            if( activeSort)
            {
                activeSort.classList.remove('facet-mobile-sort-active');
            }
            e.currentTarget.classList.add("facet-mobile-sort-active");
            var value = element.value;
            Shopify.queryParams.sort_by = value;
            location.search = new URLSearchParams(Shopify.queryParams).toString();
        })
    }

});